import React from 'react';
import InternshipApplicationNew from './InternshipApplicationNew';

/**
 * This is a wrapper component that simply forwards to the new implementation
 * to avoid having to update all import references throughout the app.
 */
const InternshipApplication = (props) => {
  return <InternshipApplicationNew {...props} />;
};

export default InternshipApplication;
